import { SubscribableOrValue, PureComputed } from "knockout";
import { injectable } from "inversify";

export interface JSONTool {
    action?: () => void
    icon?: SubscribableOrValue<string | undefined>
    tooltip?: SubscribableOrValue<string | undefined>
    css?: SubscribableOrValue<string | undefined>

    isSpecial?: SubscribableOrValue<boolean>
    isActive?: SubscribableOrValue<boolean>
    isDisabled?: SubscribableOrValue<boolean>
    isVisible?: SubscribableOrValue<boolean>
}

export class Tool {
    action: () => void
    icon: PureComputed<string | undefined>
    tooltip: PureComputed<string | undefined>
    css: PureComputed<string | undefined>

    isSpecial: PureComputed<boolean>
    isActive: PureComputed<boolean>
    isDisabled: PureComputed<boolean>
    isVisible: PureComputed<boolean>

    constructor(jsonModel: JSONTool) {
        this.action = jsonModel.action ?? _.noop;
        this.icon = ko.observable(jsonModel.icon).unwrap();
        this.tooltip = ko.observable(jsonModel.tooltip).unwrap();
        this.css = ko.observable(jsonModel.css).unwrap();

        this.isSpecial = ko.observable(jsonModel.isSpecial).unwrap().default(false);
        this.isActive = ko.observable(jsonModel.isActive).unwrap().default(false);
        this.isDisabled = ko.observable(jsonModel.isDisabled).unwrap().default(false);
        this.isVisible = ko.observable(jsonModel.isVisible).unwrap().default(true);
    }
}

@injectable()
export class ToolVM {
    constructor(tool: Tool, node: Node) {
        var cTooltip = tool.tooltip,
            cCSS = tool.css;

        var cIsSpecial = tool.isSpecial,
            cIsActive = tool.isActive,
            cIsDisabled = tool.isDisabled,
            cIsVisible = tool.isVisible;

        ko.applyBindingsToNode(node, {
            'click': tool.action,
            'visible': cIsVisible,

            'css': {
                'chat-editor__tool': true,
                'chat-editor__tool--active': cIsActive,
                'chat-editor__tool--disabled': cIsDisabled,
                'chat-editor__tool--special': cIsSpecial
            },

            'tooltip': { message: cTooltip }
        }, this);

        ko.applyBindingsToNode(node, {
            'css': cCSS
        }, this);
    }
}